export enum ActionTypes{
    LANG_UPDATE = "LANG_UPDATE",
    LANG_CLEAR = "LANG_CLEAR",
    LANG_SETTINGS = "LANG_SETTINGS"
}